import type { Character } from '@minglun/domain';

export const inventoryFields = ['wheelCount', 'backpackFragmentCount', 'itemFragmentCount'] as const;
export type InventoryField = typeof inventoryFields[number];
export type EntryOrder = 'row' | InventoryField;
export const inventoryLabels: Record<InventoryField, string> = { wheelCount:'命轮数量', backpackFragmentCount:'背包碎片', itemFragmentCount:'道具碎片' };
export interface EntryCell { id: string; field: InventoryField }
export function adjacentCell(ids: string[], current: EntryCell, direction: number, order: EntryOrder): EntryCell | undefined {
  const row = ids.indexOf(current.id);
  if (row < 0) return;
  if (order !== 'row') { const id = ids[row + direction]; return id ? { id, field: order } : undefined; }
  const index = row * 3 + inventoryFields.indexOf(current.field) + direction;
  return index >= 0 && index < ids.length * 3 ? { id:ids[Math.floor(index / 3)]!, field:inventoryFields[index % 3]! } : undefined;
}
export interface PastedInventory { line: number; name: string; characterId?: string; values?: Record<InventoryField, number>; error?: string }
/** TSV is lossless for Excel paste; CSV is deliberately not guessed (commas may be thousands separators). */
export function parseInventoryPaste(text: string, characters: Pick<Character,'id'|'name'>[]): PastedInventory[] {
  const seen = new Set<string>();
  return text.split(/\r?\n/).map((raw,index)=>({raw,line:index+1})).filter(x=>x.raw.trim()).flatMap<PastedInventory>(({raw,line}) => {
    const columns = raw.split('\t').map(x=>x.trim());
    if (line === 1 && /^(伙伴|伙伴名称|名称|角色)$/.test(columns[0]!) && columns[1]?.includes('命轮')) return [];
    const name = columns[0] ?? '';
    if (columns.length !== 4) return [{line,name,error:'需要四列：伙伴、命轮、背包碎片、道具碎片'}];
    const matches = characters.filter(x=>x.name === name || x.id === name);
    if (matches.length !== 1) return [{line,name,error:matches.length ? '名称重复，请使用角色编号' : '没有匹配的伙伴'}];
    const characterId = matches[0]!.id;
    if (seen.has(characterId)) return [{line,name,error:'同一伙伴重复，请合并后再导入'}];
    seen.add(characterId);
    const values = columns.slice(1).map(x=>/^(\d+|\d{1,3}(,\d{3})+)$/.test(x) ? Number(x.replaceAll(',','')) : NaN);
    if (values.some(x=>!Number.isSafeInteger(x) || x < 0)) return [{line,name,error:'数量必须是非负安全整数，空白不能自动当作 0'}];
    return [{line,name,characterId,values:{wheelCount:values[0]!,backpackFragmentCount:values[1]!,itemFragmentCount:values[2]!}}];
  });
}
